var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9694 0.333313C30.5056 0.333313 33.897 1.73807 36.3975 4.23856C38.898 6.73904 40.3027 10.1304 40.3027 13.6666C40.3027 17.2029 38.898 20.5943 36.3975 23.0947C33.897 25.5952 30.5056 27 26.9694 27C23.4332 27 20.0418 25.5952 17.5413 23.0947C15.0408 20.5943 13.6361 17.2029 13.6361 13.6666C13.6361 10.1304 15.0408 6.73904 17.5413 4.23856C20.0418 1.73807 23.4332 0.333313 26.9694 0.333313ZM26.9694 33.6666C41.7027 33.6666 53.6361 39.6333 53.6361 47V53.6666H0.302734V47C0.302734 39.6333 12.2361 33.6666 26.9694 33.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconWhite);
export default __webpack_public_path__ + "static/media/userIconWhite.1c7d314a40dc81a80f25c153b214f811.svg";
export { ForwardRef as ReactComponent };